/**
 * Ported verbatim from moonrakers-legacy (Prestige 5.4.3) assets/custom_theme.js.
 *
 * The fade/scale animation logic (.js-fade > .fade-in/.slide-up, .js-scroll-scale--item) is
 * generic and safe to reuse, but it only affects elements that carry those classes — currently
 * only the legacy fr_newtop and sec_origin sections do (not yet ported to this theme; see
 * docs/legacy-content/homepage-index.md). It's harmless to load before those sections exist.
 *
 * The MutationObserver at the bottom of this file (watching for ".storecrm-status-widget")
 * is legacy/store-specific: it reformats a widget injected by a third-party LINE integration
 * app (StoreCRM). It will simply no-op if that app/widget isn't installed on this store — confirm
 * whether the app is still in use before relying on this block.
 */
customTheme_func = {};
customTheme_func = {
  init:function () {
    // スクロール時にフェードイン・スライドアップする
    const containers = document.querySelectorAll('.js-fade');
    function applyAnimations() {
        containers.forEach((container) => {
            const images = container.querySelectorAll('.fade-in');
            images.forEach((image, index) => {
                // フェードインのクラスを持つ場合
                if (image.classList.contains('fade-in')) {
                    const imagePosition = image.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    if (imagePosition.top < windowHeight && imagePosition.bottom >= 0) {
                        setTimeout(() => {
                            image.style.opacity = 1;
                        }, 200 * index);
                    }
                }
                // スライドアップのクラスを持つ場合
                if (image.classList.contains('slide-up')) {
                    const imagePosition = image.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    if (imagePosition.top < windowHeight && imagePosition.bottom >= 0) {
                        setTimeout(() => {
                            image.style.transform = 'translateY(0)';
                        }, 200 * index);
                    }
                }
            });
        });
    }

    // スクロール時に画像サイズを変える
    const images = document.querySelectorAll('.js-scroll-scale--item');

    function scaleImagesOnScroll() {
      images.forEach((image) => {
        const imagePosition = image.getBoundingClientRect();
        const windowHeight = window.innerHeight;
  
        if (imagePosition.top < windowHeight && imagePosition.bottom >= 0) {
          // 画像が画面内に入った場合
          const scrollRatio = (windowHeight - imagePosition.top) / windowHeight;
          const scaleValue = 1.3 - (0.4 * scrollRatio);
  
          if (scaleValue >= 1) {
            // 最小スケール(1)以上の場合にのみスケーリングを適用
            image.style.transform = `scale(${scaleValue})`;
          } else {
            // 最小スケール(1)に達したらスケーリングを停止
            image.style.transform = 'scale(1)';
          }
        }
      });
    }

    // 初回実行
    applyAnimations();
    scaleImagesOnScroll();

    // スクロールイベントを監視
    window.addEventListener('scroll', applyAnimations);
    window.addEventListener('scroll', scaleImagesOnScroll);
  }
}

window.addEventListener('load',()=> {
  customTheme_func.init();
},false);

document.addEventListener('shopify:section:load',()=> {
  customTheme_func.init();
},false);

const observer = new MutationObserver(() => {
  const container = document.querySelector(".storecrm-status-widget > div");
  if (!container) return;

  const statusOff = container.querySelector(".storecrm-off");
  const statusOn = container.querySelector(".storecrm-on");
  const status = statusOff || statusOn;
  const labelText = container.childNodes[0]; // "LINE設定: " のテキストノード
  const button = container.querySelector(".storecrm-button");

  if (button && labelText && status) {
    // ボタンテキストを状態によって変更
    if (statusOff) {
      button.textContent = "LINE連携する";
    } else if (statusOn) {
      button.textContent = "連携解除する";
    }

    // 並び替え（ボタンを一番左へ）
    container.insertBefore(button, container.firstChild);
    container.appendChild(labelText);
    container.appendChild(status);

    // 処理後に監視停止
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });






